import { render, staticRenderFns } from "./OtherOfficeMessage.vue?vue&type=template&id=bf88501e&scoped=true&lang=pug"
import script from "./OtherOfficeMessage.vue?vue&type=script&lang=ts"
export * from "./OtherOfficeMessage.vue?vue&type=script&lang=ts"
import style0 from "./OtherOfficeMessage.vue?vue&type=style&index=0&id=bf88501e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf88501e",
  null
  
)

export default component.exports